// @flow
import * as React from 'react';
import { FollowUps } from './follow-ups';
import { useOutdatedFollowUps } from '../../hooks/use-outdated-follow-ups';
import { Link, useParams } from 'react-router-dom';
import { Stack, Typography, Link as MuiLink } from '@mui/material';
import { BlinkingWarningIcon } from '../../../../features';
import { useFollowUpsQuery, useMissedAppsTagId } from '../../../../shared';
import { keycloak } from '@coverright/shared/keycloak';

export const TodayFollowUps = () => {
  const missingAppsTagId = useMissedAppsTagId();
  const {agentId} = useParams<{ agentId?: string }>();
  const outdated = useOutdatedFollowUps(agentId)
  const outdatedLength =  outdated?.length;

  if (!missingAppsTagId) {
    return null;
  }

  return <>
    {!!outdatedLength && <Stack mb={1} direction={'row'} gap={1} alignItems={'center'}>
      <BlinkingWarningIcon />
      <Typography variant={'body2'} color={'error'} fontWeight={500}>
        You have {outdatedLength} Follow Up that are dates prior to today's date. Please review the
        disposition and Next Contact Date. <MuiLink component={Link} color={'#0288d1'} to={`/dashboard/outdated-follow-ups/${agentId || keycloak?.tokenParsed?.sub}`}>Show outdated</MuiLink>
      </Typography>
    </Stack>}
    <FollowUps suffix={''} title={'Todays Follow-Ups'}
               excludedTagsIds={[missingAppsTagId]}
               dataSource={useFollowUpsQuery} agent={agentId || keycloak?.tokenParsed?.sub} />
  </>;
};
